import React, { useEffect, useState } from 'react';
import { BookOpen, Video, Calendar, Clock, CheckCircle, Plus, Book, AlertCircle, Check, X, User, ChevronDown, Edit2, Trash2, Users, XCircle } from 'lucide-react';
// Ders renkleri
const SUBJECT_COLORS: Record<string, string> = {
  MATEMATİK: 'from-blue-600 to-cyan-600',
  TÜRKÇE: 'from-red-600 to-pink-600',
  'FEN BİLİMLERİ': 'from-green-600 to-emerald-600',
  'T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK': 'from-amber-600 to-orange-600',
  İNGİLİZCE: 'from-indigo-600 to-purple-600',
  'DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ': 'from-teal-600 to-cyan-600'
};
interface TeacherAssignment {
  id: number;
  title: string;
  subject: string;
  type: 'test' | 'video' | 'physical-book';
  dueDate: string;
  daysLeft: number;
  description: string;
  bookName?: string;
  pageRange?: string;
  assignedClasses: string[];
  teacherName: string;
  totalStudents: number;
  waitingApproval: number;
  approved: number;
  pending: number;
  status: 'active' | 'completed';
  targetPath?: string;
}
interface StudentHomeworkStatus {
  studentId: number;
  studentName: string;
  studentClass: string;
  homeworkId: number;
  markedAsComplete: boolean;
  markedDate?: string;
  teacherApproved?: boolean;
  teacherRejected?: boolean;
  approvalDate?: string;
  teacherNote?: string;
  score?: number;
  total?: number;
}
export default function HomeworkTracking() {
  const [activeTab, setActiveTab] = useState<'active' | 'completed'>('active');
  const [showNewHomeworkModal, setShowNewHomeworkModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showStudentListModal, setShowStudentListModal] = useState(false);
  const [selectedHomework, setSelectedHomework] = useState<TeacherAssignment | null>(null);
  const [homeworkToDelete, setHomeworkToDelete] = useState<TeacherAssignment | null>(null);
  const [selectedStudent, setSelectedStudent] = useState<StudentHomeworkStatus | null>(null);
  const [teacherNote, setTeacherNote] = useState('');
  const [selectedClass, setSelectedClass] = useState<string>('all');
  // State'ler
  const [assignments, setAssignments] = useState<TeacherAssignment[]>([{
    id: 1,
    title: 'Üslü Sayılar Test Çalışması',
    subject: 'MATEMATİK',
    type: 'test',
    dueDate: '2025-10-26',
    daysLeft: 3,
    description: 'Üslü sayılar konusunu kapsayan 20 soruluk test çalışması.',
    assignedClasses: ['7-A', '7-B'],
    teacherName: 'Mehmet Kaya',
    totalStudents: 52,
    waitingApproval: 0,
    approved: 38,
    pending: 14,
    status: 'active',
    targetPath: '/soru-cozum'
  }, {
    id: 2,
    title: 'Cümlenin Öğeleri Konu Videosu',
    subject: 'TÜRKÇE',
    type: 'video',
    dueDate: '2025-10-28',
    daysLeft: 5,
    description: 'Cümlenin öğeleri konusunu anlatan video izleme görevi.',
    assignedClasses: ['8-A'],
    teacherName: 'Fatma Yıldız',
    totalStudents: 28,
    waitingApproval: 5,
    approved: 18,
    pending: 5,
    status: 'active',
    targetPath: '/konu-anlatim'
  }, {
    id: 3,
    title: 'Limit Matematik Test Kitabı',
    subject: 'MATEMATİK',
    type: 'physical-book',
    dueDate: '2025-10-24',
    daysLeft: 1,
    description: 'Köklü sayılar konusu fiziki test kitabı çalışması.',
    assignedClasses: ['7-A'],
    teacherName: 'Mehmet Kaya',
    bookName: 'Limit Matematik Test Kitabı',
    pageRange: 'Test 8-10',
    totalStudents: 26,
    waitingApproval: 3,
    approved: 15,
    pending: 8,
    status: 'active'
  }]);
  const [students, setStudents] = useState<StudentHomeworkStatus[]>([{
    studentId: 1,
    studentName: 'Ayşe Demir',
    studentClass: '8-A',
    homeworkId: 2,
    markedAsComplete: true,
    markedDate: '2025-10-22',
    teacherApproved: false
  }, {
    studentId: 2,
    studentName: 'Mehmet Yılmaz',
    studentClass: '8-A',
    homeworkId: 2,
    markedAsComplete: true,
    markedDate: '2025-10-22',
    teacherApproved: false
  }, {
    studentId: 3,
    studentName: 'Zeynep Kaya',
    studentClass: '7-A',
    homeworkId: 3,
    markedAsComplete: true,
    markedDate: '2025-10-23',
    teacherApproved: false
  }, {
    studentId: 4,
    studentName: 'Can Özdemir',
    studentClass: '7-A',
    homeworkId: 3,
    markedAsComplete: false,
    teacherApproved: false
  }, {
    studentId: 5,
    studentName: 'Elif Yıldız',
    studentClass: '7-A',
    homeworkId: 3,
    markedAsComplete: false,
    teacherApproved: false
  }]);
  // Yeni/Düzenle ödev formu
  const [homeworkForm, setHomeworkForm] = useState({
    title: '',
    subject: 'MATEMATİK',
    type: 'test' as 'test' | 'video' | 'physical-book',
    description: '',
    dueDate: '',
    bookName: '',
    pageRange: '',
    assignedClasses: [] as string[]
  });
  // Sınıf listesi
  const availableClasses = ['7-A', '7-B', '7-C', '8-A', '8-B', '8-C'];
  // Tab'a göre ödevleri filtrele
  const getFilteredHomeworks = () => {
    return assignments.filter(hw => hw.status === activeTab);
  };
  // Öğrencileri getir
  const getStudentsForHomework = (homeworkId: number, classFilter: string = 'all') => {
    let filtered = students.filter(s => s.homeworkId === homeworkId);
    if (classFilter !== 'all') {
      filtered = filtered.filter(s => s.studentClass === classFilter);
    }
    return filtered;
  };
  // Gün kaldı
  const getDaysLeftText = (days: number) => {
    if (days < 0) return 'Süre Doldu';
    if (days === 0) return 'Bugün Son Gün!';
    if (days === 1) return 'Yarın Son Gün!';
    return `${days} gün kaldı`;
  };
  const getDaysLeftColor = (days: number) => {
    if (days <= 1) return 'bg-red-500/20 text-red-400';
    if (days <= 3) return 'bg-orange-500/20 text-orange-400';
    return 'bg-yellow-500/20 text-yellow-400';
  };
  // Icon
  const getTypeIcon = (type: 'test' | 'video' | 'physical-book') => {
    switch (type) {
      case 'test':
        return BookOpen;
      case 'video':
        return Video;
      case 'physical-book':
        return Book;
    }
  };
  // Sınıf seçimi toggle
  const toggleClassSelection = (className: string) => {
    if (homeworkForm.assignedClasses.includes(className)) {
      setHomeworkForm({
        ...homeworkForm,
        assignedClasses: homeworkForm.assignedClasses.filter(c => c !== className)
      });
    } else {
      setHomeworkForm({
        ...homeworkForm,
        assignedClasses: [...homeworkForm.assignedClasses, className]
      });
    }
  };
  // Yeni ödev oluştur
  const handleCreateHomework = () => {
    const newAssignment: TeacherAssignment = {
      id: Math.max(...assignments.map(a => a.id), 0) + 1,
      title: homeworkForm.title,
      subject: homeworkForm.subject,
      type: homeworkForm.type,
      dueDate: homeworkForm.dueDate,
      daysLeft: Math.ceil((new Date(homeworkForm.dueDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)),
      description: homeworkForm.description,
      bookName: homeworkForm.bookName,
      pageRange: homeworkForm.pageRange,
      assignedClasses: homeworkForm.assignedClasses,
      teacherName: 'Öğretmen Adı',
      totalStudents: homeworkForm.assignedClasses.length * 26,
      waitingApproval: 0,
      approved: 0,
      pending: homeworkForm.assignedClasses.length * 26,
      status: 'active',
      targetPath: homeworkForm.type === 'test' ? '/soru-cozum' : '/konu-anlatim'
    };
    setAssignments([newAssignment, ...assignments]);
    setShowNewHomeworkModal(false);
    resetForm();
  };
  // Ödev düzenle
  const handleEditHomework = () => {
    if (!selectedHomework) return;
    setAssignments(assignments.map(hw => hw.id === selectedHomework.id ? {
      ...hw,
      title: homeworkForm.title,
      subject: homeworkForm.subject,
      type: homeworkForm.type,
      description: homeworkForm.description,
      dueDate: homeworkForm.dueDate,
      bookName: homeworkForm.bookName,
      pageRange: homeworkForm.pageRange,
      assignedClasses: homeworkForm.assignedClasses,
      daysLeft: Math.ceil((new Date(homeworkForm.dueDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))
    } : hw));
    setShowEditModal(false);
    setSelectedHomework(null);
    resetForm();
  };
  // Ödev sil
  const handleDeleteHomework = () => {
    if (!homeworkToDelete) return;
    setAssignments(assignments.filter(hw => hw.id !== homeworkToDelete.id));
    setShowDeleteConfirm(false);
    setHomeworkToDelete(null);
  };
  // Formu sıfırla
  const resetForm = () => {
    setHomeworkForm({
      title: '',
      subject: 'MATEMATİK',
      type: 'test',
      description: '',
      dueDate: '',
      bookName: '',
      pageRange: '',
      assignedClasses: []
    });
  };
  // Düzenleme için formu doldur
  const openEditModal = (homework: TeacherAssignment) => {
    setSelectedHomework(homework);
    setHomeworkForm({
      title: homework.title,
      subject: homework.subject,
      type: homework.type,
      description: homework.description,
      dueDate: homework.dueDate,
      bookName: homework.bookName || '',
      pageRange: homework.pageRange || '',
      assignedClasses: homework.assignedClasses
    });
    setShowEditModal(true);
  };
  // Öğrenci onaylama
  const handleApproveStudent = (student: StudentHomeworkStatus) => {
    setStudents(students.map(s => s.studentId === student.studentId && s.homeworkId === student.homeworkId ? {
      ...s,
      teacherApproved: true,
      approvalDate: new Date().toISOString(),
      teacherNote: teacherNote
    } : s));
    // İstatistikleri güncelle
    if (selectedHomework) {
      setAssignments(assignments.map(hw => hw.id === selectedHomework.id ? {
        ...hw,
        waitingApproval: hw.waitingApproval - 1,
        approved: hw.approved + 1
      } : hw));
    }
    setSelectedStudent(null);
    setTeacherNote('');
  };
  // Öğrenci reddetme
  const handleRejectStudent = (student: StudentHomeworkStatus) => {
    setStudents(students.map(s => s.studentId === student.studentId && s.homeworkId === student.homeworkId ? {
      ...s,
      teacherRejected: true,
      markedAsComplete: false,
      teacherNote: teacherNote
    } : s));
    // İstatistikleri güncelle
    if (selectedHomework) {
      setAssignments(assignments.map(hw => hw.id === selectedHomework.id ? {
        ...hw,
        waitingApproval: hw.waitingApproval - 1,
        pending: hw.pending + 1
      } : hw));
    }
    setSelectedStudent(null);
    setTeacherNote('');
  };
  // Ödev Kartı
  const HomeworkCard = ({
    homework
  }: {
    homework: TeacherAssignment;
  }) => {
    const gradientClass = SUBJECT_COLORS[homework.subject] || 'from-gray-600 to-gray-800';
    const Icon = getTypeIcon(homework.type);
    return <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-green-600" data-id="element-955">
        <div className="bg-black/90 p-5 rounded-xl space-y-4" data-id="element-956">
          {/* Header */}
          <div className="flex justify-between items-start" data-id="element-957">
            <div className="flex-1 space-y-2" data-id="element-958">
              <div className="flex items-center gap-2 flex-wrap" data-id="element-959">
                <div className={`p-1.5 rounded-md bg-gradient-to-r ${gradientClass}`} data-id="element-960">
                  <Icon className="w-4 h-4 text-white" data-id="element-961" />
                </div>
                <span className="text-sm font-medium text-gray-300" data-id="element-962">
                  {homework.subject}
                </span>
                <span className="text-xs px-2 py-0.5 rounded-full bg-emerald-500/20 text-emerald-400" data-id="element-963">
                  {homework.assignedClasses.join(', ')}
                </span>
              </div>
              <h3 className="text-lg font-bold text-white leading-tight" data-id="element-964">
                {homework.title}
              </h3>
              <p className="text-sm text-gray-400" data-id="element-965">{homework.description}</p>
              {homework.type === 'physical-book' && <div className="flex items-center gap-2 text-sm text-blue-400" data-id="element-966">
                  <Book className="w-4 h-4" data-id="element-967" />
                  <span data-id="element-968">
                    {homework.bookName} - {homework.pageRange}
                  </span>
                </div>}
            </div>
            {/* Süre Badge */}
            {homework.status === 'active' && <div className={`px-3 py-1 text-xs font-medium rounded-full flex items-center gap-1.5 ${getDaysLeftColor(homework.daysLeft)}`} data-id="element-969">
                <Clock className="w-3 h-3" data-id="element-970" />
                {getDaysLeftText(homework.daysLeft)}
              </div>}
            {homework.status === 'completed' && <div className="px-3 py-1 text-xs font-medium rounded-full flex items-center gap-1.5 bg-green-500/20 text-green-400" data-id="element-971">
                <CheckCircle className="w-3 h-3" data-id="element-972" />
                Tamamlandı
              </div>}
          </div>
          {/* İstatistikler */}
          <div className="border-t border-gray-800 pt-4 grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-973">
            <div data-id="element-974">
              <p className="text-xs text-gray-400" data-id="element-975">Toplam</p>
              <p className="text-lg font-bold text-white" data-id="element-976">
                {homework.totalStudents}
              </p>
            </div>
            <div data-id="element-977">
              <p className="text-xs text-gray-400" data-id="element-978">Onaylanan</p>
              <p className="text-lg font-bold text-green-400" data-id="element-979">
                {homework.approved}
              </p>
            </div>
            <div data-id="element-980">
              <p className="text-xs text-gray-400" data-id="element-981">Bekliyor</p>
              <p className="text-lg font-bold text-blue-400" data-id="element-982">
                {homework.waitingApproval}
              </p>
            </div>
            <div data-id="element-983">
              <p className="text-xs text-gray-400" data-id="element-984">Beklemede</p>
              <p className="text-lg font-bold text-orange-400" data-id="element-985">
                {homework.pending}
              </p>
            </div>
          </div>
          {/* Butonlar */}
          <div className="border-t border-gray-800 pt-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3" data-id="element-986">
            <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-987">
              <Calendar className="w-4 h-4" data-id="element-988" />
              <span data-id="element-989">
                Son Teslim:{' '}
                {new Date(homework.dueDate).toLocaleDateString('tr-TR', {
                day: 'numeric',
                month: 'long'
              })}
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-990">
              <button onClick={() => {
              setSelectedHomework(homework);
              setShowStudentListModal(true);
            }} className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-cyan-600 text-white rounded-lg hover:opacity-90 transition-opacity" data-id="element-991">
                <Users className="w-4 h-4" data-id="element-992" />
                Öğrenci Listesi
              </button>
              <button onClick={() => openEditModal(homework)} className="flex items-center gap-2 px-3 py-2 bg-white/5 hover:bg-white/10 text-white rounded-lg transition-colors" data-id="element-993">
                <Edit2 className="w-4 h-4" data-id="element-994" />
              </button>
              <button onClick={() => {
              setHomeworkToDelete(homework);
              setShowDeleteConfirm(true);
            }} className="flex items-center gap-2 px-3 py-2 bg-red-500/10 hover:bg-red-500/20 text-red-400 rounded-lg transition-colors" data-id="element-995">
                <Trash2 className="w-4 h-4" data-id="element-996" />
              </button>
            </div>
          </div>
        </div>
      </div>;
  };
  return <div className="space-y-6" data-id="element-997">
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-998">
        <h1 className="text-3xl font-bold text-white" data-id="element-999">Ödev Yönetimi</h1>
        <button onClick={() => {
        resetForm();
        setShowNewHomeworkModal(true);
      }} className="flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-emerald-600 to-green-600 text-white font-semibold rounded-lg hover:opacity-90 transition-opacity" data-id="element-1000">
          <Plus className="w-5 h-5" data-id="element-1001" />
          Yeni Ödev Oluştur
        </button>
      </div>
      {/* Tabs - 2 Tab */}
      <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-green-600 max-w-md" data-id="element-1002">
        <div className="bg-black/90 rounded-xl p-1" data-id="element-1003">
          <div className="flex" data-id="element-1004">
            <button onClick={() => setActiveTab('active')} className={`flex-1 py-3 px-4 rounded-lg text-center font-medium transition-all ${activeTab === 'active' ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white shadow-lg' : 'text-gray-400 hover:bg-white/5'}`} data-id="element-1005">
              Aktif Ödevler
            </button>
            <button onClick={() => setActiveTab('completed')} className={`flex-1 py-3 px-4 rounded-lg text-center font-medium transition-all ${activeTab === 'completed' ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white shadow-lg' : 'text-gray-400 hover:bg-white/5'}`} data-id="element-1006">
              Tamamlananlar
            </button>
          </div>
        </div>
      </div>
      {/* Ödevler */}
      <div className="space-y-4" data-id="element-1007">
        {getFilteredHomeworks().length > 0 ? getFilteredHomeworks().map(hw => <HomeworkCard key={hw.id} homework={hw} data-id="element-1008" />) : <div className="text-center py-16 bg-black/40 rounded-xl" data-id="element-1009">
            <div className="flex flex-col items-center gap-3" data-id="element-1010">
              <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center" data-id="element-1011">
                <BookOpen className="w-8 h-8 text-emerald-400" data-id="element-1012" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-1013">
                {activeTab === 'active' ? 'Henüz Aktif Ödev Yok' : 'Tamamlanmış Ödev Yok'}
              </h3>
              <p className="text-gray-400 max-w-md" data-id="element-1014">
                {activeTab === 'active' && 'Yeni bir ödev oluşturmak için yukarıdaki butona tıklayın.'}
                {activeTab === 'completed' && 'Tamamlanan ödevler burada listelenecek.'}
              </p>
            </div>
          </div>}
      </div>
      {/* Yeni Ödev Modal */}
      {showNewHomeworkModal && <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-1015">
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-green-600 w-full max-w-2xl max-h-[90vh] overflow-y-auto" data-id="element-1016">
            <div className="bg-black/90 rounded-xl p-6" data-id="element-1017">
              <div className="flex justify-between items-center mb-6" data-id="element-1018">
                <h2 className="text-2xl font-bold text-white" data-id="element-1019">
                  Yeni Ödev Oluştur
                </h2>
                <button onClick={() => setShowNewHomeworkModal(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-1020">
                  <X className="w-6 h-6" data-id="element-1021" />
                </button>
              </div>
              <div className="space-y-4" data-id="element-1022">
                {/* Başlık */}
                <div data-id="element-1023">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1024">
                    Ödev Başlığı
                  </label>
                  <input type="text" value={homeworkForm.title} onChange={e => setHomeworkForm({
                ...homeworkForm,
                title: e.target.value
              })} className="w-full px-4 py-3 bg-white/5 border border-emerald-500/30 rounded-lg text-white focus:outline-none focus:border-emerald-500" placeholder="Örn: Üslü Sayılar Test Çalışması" data-id="element-1025" />
                </div>
                {/* Ders ve Tür - Yeşil Select */}
                <div className="grid grid-cols-2 gap-4" data-id="element-1026">
                  <div data-id="element-1027">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1028">
                      Ders
                    </label>
                    <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-green-600" data-id="element-1029">
                      <select value={homeworkForm.subject} onChange={e => setHomeworkForm({
                    ...homeworkForm,
                    subject: e.target.value
                  })} className="w-full px-4 py-3 bg-black/90 rounded-lg text-white focus:outline-none appearance-none cursor-pointer" data-id="element-1030">
                        <option value="MATEMATİK" data-id="element-1031">Matematik</option>
                        <option value="TÜRKÇE" data-id="element-1032">Türkçe</option>
                        <option value="FEN BİLİMLERİ" data-id="element-1033">Fen Bilimleri</option>
                        <option value="T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK" data-id="element-1034">
                          İnkılap Tarihi
                        </option>
                        <option value="İNGİLİZCE" data-id="element-1035">İngilizce</option>
                        <option value="DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ" data-id="element-1036">
                          Din Kültürü
                        </option>
                      </select>
                    </div>
                  </div>
                  <div data-id="element-1037">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1038">
                      Ödev Türü
                    </label>
                    <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-green-600" data-id="element-1039">
                      <select value={homeworkForm.type} onChange={e => setHomeworkForm({
                    ...homeworkForm,
                    type: e.target.value as 'test' | 'video' | 'physical-book'
                  })} className="w-full px-4 py-3 bg-black/90 rounded-lg text-white focus:outline-none appearance-none cursor-pointer" data-id="element-1040">
                        <option value="test" data-id="element-1041">Site İçi Test</option>
                        <option value="video" data-id="element-1042">Konu Anlatım Videosu</option>
                        <option value="physical-book" data-id="element-1043">
                          Fiziki Test Kitabı
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                {/* Fiziki Kitap */}
                {homeworkForm.type === 'physical-book' && <div className="grid grid-cols-2 gap-4 p-4 bg-blue-500/10 border border-blue-500/30 rounded-lg" data-id="element-1044">
                    <div data-id="element-1045">
                      <label className="block text-sm font-medium text-blue-300 mb-2" data-id="element-1046">
                        Kitap Adı
                      </label>
                      <input type="text" value={homeworkForm.bookName} onChange={e => setHomeworkForm({
                  ...homeworkForm,
                  bookName: e.target.value
                })} className="w-full px-4 py-2 bg-white/5 border border-blue-500/30 rounded-lg text-white focus:outline-none focus:border-blue-500" placeholder="Örn: Limit Matematik Test Kitabı" data-id="element-1047" />
                    </div>
                    <div data-id="element-1048">
                      <label className="block text-sm font-medium text-blue-300 mb-2" data-id="element-1049">
                        Sayfa/Test Aralığı
                      </label>
                      <input type="text" value={homeworkForm.pageRange} onChange={e => setHomeworkForm({
                  ...homeworkForm,
                  pageRange: e.target.value
                })} className="w-full px-4 py-2 bg-white/5 border border-blue-500/30 rounded-lg text-white focus:outline-none focus:border-blue-500" placeholder="Örn: Test 8-10" data-id="element-1050" />
                    </div>
                  </div>}
                {/* Açıklama */}
                <div data-id="element-1051">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1052">
                    Açıklama
                  </label>
                  <textarea value={homeworkForm.description} onChange={e => setHomeworkForm({
                ...homeworkForm,
                description: e.target.value
              })} rows={3} className="w-full px-4 py-3 bg-white/5 border border-emerald-500/30 rounded-lg text-white focus:outline-none focus:border-emerald-500" placeholder="Ödev hakkında detaylı açıklama..." data-id="element-1053" />
                </div>
                {/* Son Teslim */}
                <div data-id="element-1054">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1055">
                    Son Teslim Tarihi
                  </label>
                  <input type="date" value={homeworkForm.dueDate} onChange={e => setHomeworkForm({
                ...homeworkForm,
                dueDate: e.target.value
              })} className="w-full px-4 py-3 bg-white/5 border border-emerald-500/30 rounded-lg text-white focus:outline-none focus:border-emerald-500 [color-scheme:dark]" data-id="element-1056" />
                </div>
                {/* Sınıf Seçimi */}
                <div data-id="element-1057">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1058">
                    Sınıf Seçimi (Birden fazla seçebilirsiniz)
                  </label>
                  <div className="grid grid-cols-3 gap-2" data-id="element-1059">
                    {availableClasses.map(className => <button key={className} onClick={() => toggleClassSelection(className)} className={`px-4 py-2 rounded-lg font-medium transition-colors ${homeworkForm.assignedClasses.includes(className) ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white' : 'bg-white/5 text-gray-400 hover:bg-white/10'}`} data-id="element-1060">
                        {className}
                      </button>)}
                  </div>
                </div>
                {/* Butonlar */}
                <div className="flex justify-end gap-3 pt-4" data-id="element-1061">
                  <button onClick={() => setShowNewHomeworkModal(false)} className="px-6 py-2.5 bg-white/5 hover:bg-white/10 text-white rounded-lg transition-colors" data-id="element-1062">
                    İptal
                  </button>
                  <button onClick={handleCreateHomework} disabled={!homeworkForm.title || !homeworkForm.description || !homeworkForm.dueDate || homeworkForm.assignedClasses.length === 0 || homeworkForm.type === 'physical-book' && (!homeworkForm.bookName || !homeworkForm.pageRange)} className="px-6 py-2.5 bg-gradient-to-r from-emerald-600 to-green-600 text-white rounded-lg hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1063">
                    Ödevi Oluştur
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Düzenle Modal (Aynı tasarım) */}
      {showEditModal && <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-1064">
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-emerald-600 to-green-600 w-full max-w-2xl max-h-[90vh] overflow-y-auto" data-id="element-1065">
            <div className="bg-black/90 rounded-xl p-6" data-id="element-1066">
              <div className="flex justify-between items-center mb-6" data-id="element-1067">
                <h2 className="text-2xl font-bold text-white" data-id="element-1068">Ödevi Düzenle</h2>
                <button onClick={() => {
              setShowEditModal(false);
              setSelectedHomework(null);
            }} className="text-gray-400 hover:text-white transition-colors" data-id="element-1069">
                  <X className="w-6 h-6" data-id="element-1070" />
                </button>
              </div>
              {/* Aynı form alanları */}
              <div className="space-y-4" data-id="element-1071">
                <div data-id="element-1072">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1073">
                    Ödev Başlığı
                  </label>
                  <input type="text" value={homeworkForm.title} onChange={e => setHomeworkForm({
                ...homeworkForm,
                title: e.target.value
              })} className="w-full px-4 py-3 bg-white/5 border border-emerald-500/30 rounded-lg text-white focus:outline-none focus:border-emerald-500" data-id="element-1074" />
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-1075">
                  <div data-id="element-1076">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1077">
                      Ders
                    </label>
                    <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-green-600" data-id="element-1078">
                      <select value={homeworkForm.subject} onChange={e => setHomeworkForm({
                    ...homeworkForm,
                    subject: e.target.value
                  })} className="w-full px-4 py-3 bg-black/90 rounded-lg text-white focus:outline-none appearance-none cursor-pointer" data-id="element-1079">
                        <option value="MATEMATİK" data-id="element-1080">Matematik</option>
                        <option value="TÜRKÇE" data-id="element-1081">Türkçe</option>
                        <option value="FEN BİLİMLERİ" data-id="element-1082">Fen Bilimleri</option>
                        <option value="T.C. İNKILAP TARİHİ VE ATATÜRKÇÜLÜK" data-id="element-1083">
                          İnkılap Tarihi
                        </option>
                        <option value="İNGİLİZCE" data-id="element-1084">İngilizce</option>
                        <option value="DİN KÜLTÜRÜ VE AHLÂK BİLGİSİ" data-id="element-1085">
                          Din Kültürü
                        </option>
                      </select>
                    </div>
                  </div>
                  <div data-id="element-1086">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1087">
                      Ödev Türü
                    </label>
                    <div className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-emerald-600 to-green-600" data-id="element-1088">
                      <select value={homeworkForm.type} onChange={e => setHomeworkForm({
                    ...homeworkForm,
                    type: e.target.value as 'test' | 'video' | 'physical-book'
                  })} className="w-full px-4 py-3 bg-black/90 rounded-lg text-white focus:outline-none appearance-none cursor-pointer" data-id="element-1089">
                        <option value="test" data-id="element-1090">Site İçi Test</option>
                        <option value="video" data-id="element-1091">Konu Anlatım Videosu</option>
                        <option value="physical-book" data-id="element-1092">
                          Fiziki Test Kitabı
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                {homeworkForm.type === 'physical-book' && <div className="grid grid-cols-2 gap-4 p-4 bg-blue-500/10 border border-blue-500/30 rounded-lg" data-id="element-1093">
                    <div data-id="element-1094">
                      <label className="block text-sm font-medium text-blue-300 mb-2" data-id="element-1095">
                        Kitap Adı
                      </label>
                      <input type="text" value={homeworkForm.bookName} onChange={e => setHomeworkForm({
                  ...homeworkForm,
                  bookName: e.target.value
                })} className="w-full px-4 py-2 bg-white/5 border border-blue-500/30 rounded-lg text-white focus:outline-none focus:border-blue-500" data-id="element-1096" />
                    </div>
                    <div data-id="element-1097">
                      <label className="block text-sm font-medium text-blue-300 mb-2" data-id="element-1098">
                        Sayfa/Test Aralığı
                      </label>
                      <input type="text" value={homeworkForm.pageRange} onChange={e => setHomeworkForm({
                  ...homeworkForm,
                  pageRange: e.target.value
                })} className="w-full px-4 py-2 bg-white/5 border border-blue-500/30 rounded-lg text-white focus:outline-none focus:border-blue-500" data-id="element-1099" />
                    </div>
                  </div>}
                <div data-id="element-1100">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1101">
                    Açıklama
                  </label>
                  <textarea value={homeworkForm.description} onChange={e => setHomeworkForm({
                ...homeworkForm,
                description: e.target.value
              })} rows={3} className="w-full px-4 py-3 bg-white/5 border border-emerald-500/30 rounded-lg text-white focus:outline-none focus:border-emerald-500" data-id="element-1102" />
                </div>
                <div data-id="element-1103">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1104">
                    Son Teslim Tarihi
                  </label>
                  <input type="date" value={homeworkForm.dueDate} onChange={e => setHomeworkForm({
                ...homeworkForm,
                dueDate: e.target.value
              })} className="w-full px-4 py-3 bg-white/5 border border-emerald-500/30 rounded-lg text-white focus:outline-none focus:border-emerald-500 [color-scheme:dark]" data-id="element-1105" />
                </div>
                <div data-id="element-1106">
                  <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1107">
                    Sınıf Seçimi
                  </label>
                  <div className="grid grid-cols-3 gap-2" data-id="element-1108">
                    {availableClasses.map(className => <button key={className} onClick={() => toggleClassSelection(className)} className={`px-4 py-2 rounded-lg font-medium transition-colors ${homeworkForm.assignedClasses.includes(className) ? 'bg-gradient-to-r from-emerald-600 to-green-600 text-white' : 'bg-white/5 text-gray-400 hover:bg-white/10'}`} data-id="element-1109">
                        {className}
                      </button>)}
                  </div>
                </div>
                <div className="flex justify-end gap-3 pt-4" data-id="element-1110">
                  <button onClick={() => {
                setShowEditModal(false);
                setSelectedHomework(null);
              }} className="px-6 py-2.5 bg-white/5 hover:bg-white/10 text-white rounded-lg transition-colors" data-id="element-1111">
                    İptal
                  </button>
                  <button onClick={handleEditHomework} className="px-6 py-2.5 bg-gradient-to-r from-emerald-600 to-green-600 text-white rounded-lg hover:opacity-90 transition-opacity" data-id="element-1112">
                    Değişiklikleri Kaydet
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
      {/* Silme Onay Modal */}
      {showDeleteConfirm && homeworkToDelete && <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-1113">
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-red-600 to-rose-600 w-full max-w-md" data-id="element-1114">
            <div className="bg-black/90 rounded-xl p-6" data-id="element-1115">
              <div className="flex items-center gap-3 mb-4" data-id="element-1116">
                <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-1117">
                  <AlertCircle className="w-6 h-6 text-red-400" data-id="element-1118" />
                </div>
                <div data-id="element-1119">
                  <h3 className="text-xl font-bold text-white" data-id="element-1120">Ödevi Sil</h3>
                  <p className="text-sm text-gray-400" data-id="element-1121">
                    Bu işlem geri alınamaz
                  </p>
                </div>
              </div>
              <p className="text-gray-300 mb-6" data-id="element-1122">
                <strong data-id="element-1123">{homeworkToDelete.title}</strong> başlıklı ödevi silmek
                istediğinizden emin misiniz?
              </p>
              <div className="flex gap-3" data-id="element-1124">
                <button onClick={() => {
              setShowDeleteConfirm(false);
              setHomeworkToDelete(null);
            }} className="flex-1 px-4 py-2.5 bg-white/5 hover:bg-white/10 text-white rounded-lg transition-colors" data-id="element-1125">
                  İptal
                </button>
                <button onClick={handleDeleteHomework} className="flex-1 px-4 py-2.5 bg-gradient-to-r from-red-600 to-rose-600 text-white rounded-lg hover:opacity-90 transition-opacity" data-id="element-1126">
                  Ödevi Sil
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Öğrenci Listesi Modal */}
      {showStudentListModal && selectedHomework && <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4" data-id="element-1127">
          <div className="relative p-[1px] rounded-xl overflow-hidden bg-gradient-to-r from-blue-600 to-cyan-600 w-full max-w-4xl max-h-[90vh] overflow-y-auto" data-id="element-1128">
            <div className="bg-black/90 rounded-xl p-6" data-id="element-1129">
              <div className="flex justify-between items-center mb-6" data-id="element-1130">
                <div data-id="element-1131">
                  <h2 className="text-2xl font-bold text-white" data-id="element-1132">
                    {selectedHomework.title}
                  </h2>
                  <p className="text-gray-400 mt-1" data-id="element-1133">
                    Öğrenci Listesi ve Onay Yönetimi
                  </p>
                </div>
                <button onClick={() => {
              setShowStudentListModal(false);
              setSelectedHomework(null);
              setSelectedClass('all');
            }} className="text-gray-400 hover:text-white transition-colors" data-id="element-1134">
                  <X className="w-6 h-6" data-id="element-1135" />
                </button>
              </div>
              {/* Sınıf Filtresi */}
              <div className="mb-4" data-id="element-1136">
                <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1137">
                  Sınıf Filtresi
                </label>
                <div className="flex gap-2 flex-wrap" data-id="element-1138">
                  <button onClick={() => setSelectedClass('all')} className={`px-4 py-2 rounded-lg font-medium transition-colors ${selectedClass === 'all' ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white' : 'bg-white/5 text-gray-400 hover:bg-white/10'}`} data-id="element-1139">
                    Tüm Sınıflar
                  </button>
                  {selectedHomework.assignedClasses.map(cls => <button key={cls} onClick={() => setSelectedClass(cls)} className={`px-4 py-2 rounded-lg font-medium transition-colors ${selectedClass === cls ? 'bg-gradient-to-r from-blue-600 to-cyan-600 text-white' : 'bg-white/5 text-gray-400 hover:bg-white/10'}`} data-id="element-1140">
                      {cls}
                    </button>)}
                </div>
              </div>
              {/* Öğrenci Listesi */}
              <div className="space-y-3" data-id="element-1141">
                {getStudentsForHomework(selectedHomework.id, selectedClass).map(student => <div key={student.studentId} className="relative p-[1px] rounded-lg overflow-hidden bg-gradient-to-r from-gray-700 to-gray-600" data-id="element-1142">
                      <div className="bg-black/90 p-4 rounded-lg" data-id="element-1143">
                        <div className="flex justify-between items-center" data-id="element-1144">
                          <div className="flex-1" data-id="element-1145">
                            <div className="flex items-center gap-3" data-id="element-1146">
                              <h3 className="font-semibold text-white" data-id="element-1147">
                                {student.studentName}
                              </h3>
                              <span className="text-xs px-2 py-0.5 rounded-full bg-blue-500/20 text-blue-400" data-id="element-1148">
                                {student.studentClass}
                              </span>
                              {student.teacherApproved && <span className="text-xs px-2 py-0.5 rounded-full bg-green-500/20 text-green-400 flex items-center gap-1" data-id="element-1149">
                                  <CheckCircle className="w-3 h-3" data-id="element-1150" />
                                  Onaylandı
                                </span>}
                              {student.markedAsComplete && !student.teacherApproved && <span className="text-xs px-2 py-0.5 rounded-full bg-yellow-500/20 text-yellow-400" data-id="element-1151">
                                    Onay Bekliyor
                                  </span>}
                            </div>
                            {student.markedDate && <p className="text-sm text-gray-400 mt-1" data-id="element-1152">
                                İşaretleme:{' '}
                                {new Date(student.markedDate).toLocaleDateString('tr-TR')}
                              </p>}
                          </div>
                          {/* Onay Butonları */}
                          {student.markedAsComplete && !student.teacherApproved && <div className="flex gap-2" data-id="element-1153">
                                <button onClick={() => setSelectedStudent(student)} className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:opacity-90 transition-opacity" data-id="element-1154">
                                  <Check className="w-4 h-4" data-id="element-1155" />
                                  Onayla
                                </button>
                                <button onClick={() => {
                      setSelectedStudent(student);
                      setTeacherNote('');
                    }} className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-red-600 to-rose-600 text-white rounded-lg hover:opacity-90 transition-opacity" data-id="element-1156">
                                  <XCircle className="w-4 h-4" data-id="element-1157" />
                                  Reddet
                                </button>
                              </div>}
                        </div>
                        {/* Onay/Red Not Alanı */}
                        {selectedStudent?.studentId === student.studentId && <div className="mt-4 pt-4 border-t border-gray-800" data-id="element-1158">
                            <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1159">
                              Öğretmen Notu (İsteğe Bağlı)
                            </label>
                            <textarea value={teacherNote} onChange={e => setTeacherNote(e.target.value)} rows={2} className="w-full px-4 py-2 bg-white/5 border border-blue-500/30 rounded-lg text-white focus:outline-none focus:border-blue-500" placeholder="Örn: Güzel çalışmışsın, tebrikler!" data-id="element-1160" />
                            <div className="flex justify-end gap-2 mt-3" data-id="element-1161">
                              <button onClick={() => {
                      setSelectedStudent(null);
                      setTeacherNote('');
                    }} className="px-4 py-2 bg-white/5 hover:bg-white/10 text-white rounded-lg transition-colors" data-id="element-1162">
                                İptal
                              </button>
                              <button onClick={() => handleApproveStudent(student)} className="px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:opacity-90 transition-opacity" data-id="element-1163">
                                Onayı Kaydet
                              </button>
                              <button onClick={() => handleRejectStudent(student)} className="px-4 py-2 bg-gradient-to-r from-red-600 to-rose-600 text-white rounded-lg hover:opacity-90 transition-opacity" data-id="element-1164">
                                Reddi Kaydet
                              </button>
                            </div>
                          </div>}
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </div>}
    </div>;
}